import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoKrivicnoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodno krivično pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodno krivično pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno Krivično Pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong>{" "}
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Međunarodno krivično pravo je usvajanje osnovnih
                pojmova i načela međunarodnog krivičnog prava. Izučavanjem ovog
                predmeta studenti će se upoznati sa praksom kako međunarodnih
                sudova tako i domaćih sudova, kao i sa krivično pravnim izvorima
                međunarodnog prava i njihovom implementacijom u nacionalnim
                porecima. Usled sve većeg porasta broja izvršenja međunarodnih
                krivičnih djela, a naročito terorizma, studenti će se upoznati
                sa značajem inkriminacije kao i sa strategijama borbe protiv
                terorizma i modelima prevencije i zaštite.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Sticanje osnovnih znanja o međunarodnom krivičnom pravu priprema
                studenta za izučavanje i razumijevanje pojmova i pravila
                savremenog međunarodnog krivičnog prava, njegovih pojavnih
                oblika i budućih rješenja. Studenti će nakon uspješno savladanog
                predmeta moći: opisati i uporediti odnos međunarodnog krivičnog
                prava prema drugim granama prava; objasniti razliku između
                međunarodnog krivičnog prava i transnacionalnog krivičnog prava;
                opisati i objasniti procesno pravne pretpostavke za pokretanje
                postupka kao i faze postupka. Takođe, studenti će razviti
                sposobnost: rada u timu kao jednim od najčešćih načina
                zastupanja pred međunarodnim krivičnim sudovima, kao i
                prilagođavanja novonastalim situacijama i načinima njihovog
                rješavanja. Studenti će kritički prosuđivati djelovanje
                međunarodnih krivičnih sudova.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam međunarodnog krivičnog prava; Odnosa međunarodnog
                krivičnog prava i drugih grana prava; Osnovna načela
                međunarodnog krivičnog prava; Izvori međunarodnog krivičnog
                prava; Razvoj međunarodnog krivičnog prava; Vremensko i
                prostorno važenje međunarodnog krivičnog prava; Mjesto izvršenja
                krivičnog djela; Imunitet; Međunarodno krivično djelo; Krivične
                sankcije; Genocid; Ratni zločini; Zločini protiv čovječnosti;
                Agresija; Međunarodno ratno i humanitarno pravo; Komanda
                odgovornost i zajednički zločinački poduhvat; Međunarodno
                krivično pravosuđe; Međunarodni krivični sud; Povremena
                međunarodna pravosudna tijela; Mješoviti sudovi; Međunarodna
                pravna pomoć u krivičnopravnim stvarima; Ekstradicija; Ustupanje
                krivičnog gonjenja; Izvršenje strane krivične presude;
                Međunarodni krivični sud za bivšu Jugoslaviju
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe,
                samostalni rad (seminarski rad, interaktivna nastava i
                upoznavanje sa praksom crnogorskih i međunarodnih sudova),
                analiza i praćenje predmeta koji su pred međunarodnim krivičnim
                sudovima.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Pojam međunarodnog krivičnog prava; Odnosa međunarodnog
                      krivičnog prava i drugih grana prava; Osnovna načela
                      međunarodnog krivičnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Izvori međunarodnog krivičnog prava; Razvoj međunarodnog
                      krivičnog prava; Vremensko i prostorno važenje
                      međunarodnog krivičnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>Mjesto izvršenja krivičnog djela; Imunitet</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>Međunarodno krivično djelo; Krivične sankcije</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Komanda odgovornost i zajednički zločinački poduhvat
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>KOLOKVIJUM I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>Genocid</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>Ratni zločini</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>Zločini protiv čovječnosti</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>Agresija</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>Međunarodno ratno i humanitarno pravo</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>KOLOKVIJUM II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodno krivično pravosuđe; Međunarodni krivični sud;
                      Povremena međunarodna pravosudna tijela; Mješoviti sudovi
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodna pravna pomoć u krivičnopravnim stvarima;
                      Ekstradicija; Ustupanje krivičnog gonjenja; Izvršenje
                      strane krivične presude
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>Međunarodni krivični sud za bivšu Jugoslaviju</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 4.3h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3.00h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoKrivicnoPravoPM;
